<template>
  <DKitDeepBoxNodeDeepMailDialog
    v-bind="$attrs"
    v-model="model"
    :api-token="bearer as string"
    :env
    :nodes
    :organization-id
  />
</template>

<script lang="ts" setup>
import { DKitDeepBoxNodeDeepMailDialog } from '@deepcloud/deep-ui-kit'
import { useKeycloak } from '@/composables/auth/keycloak'
import type { ExtractProps } from '@deepcloud/deep-ui-utils/vue'

defineProps({
  nodes: {
    type: Array as PropType<
      ExtractProps<typeof DKitDeepBoxNodeDeepMailDialog>['nodes']
    >,
    default: () => [],
  },
  organizationId: {
    type: String,
    required: true,
  },
})

const model = defineModel({ type: Boolean, default: false })

const { bearer } = useKeycloak()
const env = import.meta.env.VITE_ENVIRONMENT
</script>
